// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9a0ab4d0","822":"ecf9342b"}[chunkId] + ".chunk.js";
};